import "./ProfileOptions.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/**
 * 
 * @returns sample page for customer support
 */
const CustomerSupport = () => {
  return (
    <Box className="main sample-page-container">
      <Typography variant="h6" className="sample-page">
        This is a sample page showcasing customer support services.
      </Typography>
    </Box>
  );
};

export default CustomerSupport;
